import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, Header, Segment } from 'semantic-ui-react';
import './style.css';
import { EntityType, MenuActions, NoteStatusEnum } from '../shared/constants';
import TagEntitiesFactoryDropDown from '../shared/TagEntitiesFactoryDropDown';
import { GetNotes } from '../../api/services/shared';

const PageHeader = ({ title, subtitle, ...rest }) => {
	const [callbacks, setCallbacks] = useState({});
	const [customComponents, setCustomComponents] = useState([]);
	const [_title, setTitle] = useState(title);
    const [isSaving, setIsSaving] = useState(false)
	const [notesCount, setNotesCount] = useState(null)

	useEffect(() => {
		setTitle(title);
	}, [title]);

  useEffect(() => {
    const entityTypeId = window.EntityTypeId;
    const entityId = window.EntityId;
    if (entityTypeId && entityId) {
      const currentHotel = window.optima.user.CurrentHotel;
      window.optima.commands.registerCustomToolbarComponent(() => (
        <TagEntitiesFactoryDropDown
          key='tags-dropdown'
          className='tags-dropdown'
          IsSystem={false}
          HotelId={currentHotel?.Id}
          ChainId={currentHotel.HotelChainId}
          EntityTypeId={entityTypeId}
          EntityId={entityId}
          clearable
          multiple
        />
      ));
    }
  }, [window.EntityTypeId, window.EntityId]);

  useEffect(() => {
    if (!callbacks[MenuActions.note]?.length) return;
    let entityId;
    let entityTypeId;

    if(window.resId){
        entityId = window.resId
        entityTypeId = EntityType.Reservation
    } else if(window.guestId){
        entityId = window.guestId
        entityTypeId = EntityType.Guest
    }

    const spec = {
      HotelID: window.optima?.user?.CurrentHotel?.Id,
      EntityTypeId: entityTypeId,
      EntityId: entityId,
      Status: NoteStatusEnum.Open,
    };

    if(spec.EntityId && spec.EntityTypeId){
        GetNotes(spec).then((notes) => setNotesCount(notes.length));
    }
  }, [
    callbacks[MenuActions.note],
    window.resId,
    window.guestId,
    window.optima?.user?.CurrentHotel?.Id,
  ]);


	const onClickMenu = () => {
		const content = document.getElementById('main-body-content');
		const sidebar = document.getElementById('sidebar-wrapper');
		if (content && sidebar) {
			if (content.classList.contains('toggled')) {
				sidebar.style.overflow = 'visible';
			} else {
				setTimeout(() => {
					sidebar.style.overflow = 'hidden';
				}, 500);
			}
			content.classList.toggle('toggled');
		}
		if (callbacks[MenuActions.toggle]) {
			callbacks[MenuActions.toggle].forEach((callback) => {
				callback();
			});
		}
	};

    //Preventing multiple consecutive clicking bursts on save button
    useEffect(() => {
      const timeoutId = setTimeout(() => setIsSaving(false), 500);
      return () => clearTimeout(timeoutId);
    }, [isSaving]);


	const onClickSave = () => {
		if (!isSaving && callbacks[MenuActions.save]) {
            setIsSaving(true)
			callbacks[MenuActions.save].forEach((callback) => {
				callback();
			});
		}
	};

	const onClickNote = () => {
		if (callbacks[MenuActions.note]) {
			callbacks[MenuActions.note].forEach((callback) => {
				callback();
			});
		}
	};

	if (window.optima) {
		if (!window.optima.commands) {
			window.optima.commands = {};
		}
		window.optima.commands.subscribe = (key, callback) => {
			setCallbacks((prev) => {
				prev[key] = prev[key] ? [...prev[key], callback] : [callback];
				return { ...prev };
			});
		};
		window.optima.commands.unsubscribe = (key, func) => {
            if (!func) {
                window.optima.commands.unSubscribeAll(key)
            }
			setCallbacks((prev) => {
                if (prev[key]) {
                    prev[key] = prev[key].filter(callback=>callback.toString() != func.toString())
                }
				return { ...prev };
			});
		};
		window.optima.commands.unSubscribeAll = (key) => {
			setCallbacks((prev) => {
				prev[key] = null;
				return { ...prev };
			});
		};
		window.optima.commands.registerCustomToolbarComponent = (component, clear) => {
			setCustomComponents((prev) => clear?[component]:[...prev, component]);
		};
	}

	window.addEventListener('message', (message) => {
		const data = message.data;
		if (data.type === 'SetTitle' && data.title) {
			setTitle(data.title);
		}
	});

	const showNote = () => {
		return callbacks[MenuActions.note] && callbacks[MenuActions.note].length;
	};

	return (
    <Segment className='page-header' raised secondary {...rest}>
      <Icon size='large' link name='list' onClick={onClickMenu} />
      <hr />

      {showNote() && (
        <Icon
          size='large'
          link
          name='sticky note'
          onClick={onClickNote}
          style={{ color: notesCount ? '#cf1b58' : '' }}
        />
      )}
      {showNote() && <hr />}
      <Icon
        size='large'
        link
        name='save'
        onClick={onClickSave}
        disabled={isSaving}
      />

      {_title && <hr />}
     {_title && <Header as='h3'>{_title}</Header>}
      {subtitle && <hr />}
      {subtitle && <Header as='h4'>{subtitle}</Header>}
      {customComponents.length > 0 && <hr />}
      {customComponents.length > 0 && customComponents.map((cmp) => cmp())}
    </Segment>
  );
};

PageHeader.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
};

export default PageHeader;
